// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Tag Selector Container ─────────────────────────────────────────────── */

.tag-selector {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.tag-selector-display {
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 24px;
}

/* ── Compact dot display (in table cell) ────────────────────────────────── */

.tag-dots {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: nowrap;
}

.tag-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
  cursor: default;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.tag-overflow {
  font-size: 0.68rem;
  color: #6b7280;
  font-weight: 600;
  white-space: nowrap;
  cursor: default;
}

.no-tags {
  color: #d1d5db;
  font-size: 0.8rem;
}

/* ── Trigger button (pencil icon) ───────────────────────────────────────── */

.tag-selector-button {
  background: none;
  color: #9ca3af;
  border: none;
  border-radius: 4px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 0.8rem;
  line-height: 1;
  padding: 0;
  transition: color 0.15s, background-color 0.15s;
  flex-shrink: 0;
}

.tag-selector-button:hover {
  color: #374151;
  background: #f3f4f6;
}

/* ── Floating dropdown (position: fixed, set via JS) ────────────────────── */

.tag-selector-dropdown {
  /* position and coordinates set via inline style in JS */
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.08);
  width: 260px;
  max-height: 320px;
  display: flex;
  flex-direction: column;
  z-index: 9999;
  overflow: hidden;
}

/* ── Dropdown header ────────────────────────────────────────────────────── */

.tag-dropdown-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px 8px;
  border-bottom: 1px solid #f3f4f6;
  flex-shrink: 0;
}

.tag-dropdown-title {
  font-size: 0.75rem;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.tag-dropdown-close {
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  font-size: 1rem;
  line-height: 1;
  padding: 2px 4px;
  border-radius: 4px;
  transition: color 0.15s, background-color 0.15s;
}

.tag-dropdown-close:hover {
  color: #374151;
  background: #f3f4f6;
}

/* ── Tag list inside dropdown ───────────────────────────────────────────── */

.tag-list {
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow-y: auto;
  flex: 1 1;
}

.tag-dropdown-empty {
  padding: 16px;
  text-align: center;
  color: #9ca3af;
  font-size: 0.85rem;
}

.tag-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.15s;
}

.tag-option:hover {
  background: #f9fafb;
}

.tag-option.selected {
  background: #eff6ff;
}

.tag-option input[type="checkbox"] {
  width: 15px;
  height: 15px;
  cursor: pointer;
  flex-shrink: 0;
  accent-color: #3b82f6;
}

/* The dot inside the dropdown is slightly larger */
.tag-option .tag-dot {
  width: 10px;
  height: 10px;
  flex-shrink: 0;
}

.tag-option-name {
  font-size: 0.8rem;
  color: #1f2937;
  font-weight: 500;
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tag-group {
  font-size: 0.7rem;
  color: #9ca3af;
  white-space: nowrap;
  margin-left: auto;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/TagSelector.css"],"names":[],"mappings":"AAAA,8EAA8E;;AAE9E;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,8EAA8E;;AAE9E;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,8EAA8E;;AAE9E;EACE,wDAAwD;EACxD,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yEAAyE;EACzE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,8EAA8E;;AAE9E;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA,mDAAmD;AACnD;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":["/* ── Tag Selector Container ─────────────────────────────────────────────── */\n\n.tag-selector {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n.tag-selector-display {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 24px;\n}\n\n/* ── Compact dot display (in table cell) ────────────────────────────────── */\n\n.tag-dots {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: nowrap;\n}\n\n.tag-dot {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  cursor: default;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.tag-overflow {\n  font-size: 0.68rem;\n  color: #6b7280;\n  font-weight: 600;\n  white-space: nowrap;\n  cursor: default;\n}\n\n.no-tags {\n  color: #d1d5db;\n  font-size: 0.8rem;\n}\n\n/* ── Trigger button (pencil icon) ───────────────────────────────────────── */\n\n.tag-selector-button {\n  background: none;\n  color: #9ca3af;\n  border: none;\n  border-radius: 4px;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 0.8rem;\n  line-height: 1;\n  padding: 0;\n  transition: color 0.15s, background-color 0.15s;\n  flex-shrink: 0;\n}\n\n.tag-selector-button:hover {\n  color: #374151;\n  background: #f3f4f6;\n}\n\n/* ── Floating dropdown (position: fixed, set via JS) ────────────────────── */\n\n.tag-selector-dropdown {\n  /* position and coordinates set via inline style in JS */\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.08);\n  width: 260px;\n  max-height: 320px;\n  display: flex;\n  flex-direction: column;\n  z-index: 9999;\n  overflow: hidden;\n}\n\n/* ── Dropdown header ────────────────────────────────────────────────────── */\n\n.tag-dropdown-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px 8px;\n  border-bottom: 1px solid #f3f4f6;\n  flex-shrink: 0;\n}\n\n.tag-dropdown-title {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #374151;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.tag-dropdown-close {\n  background: none;\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  font-size: 1rem;\n  line-height: 1;\n  padding: 2px 4px;\n  border-radius: 4px;\n  transition: color 0.15s, background-color 0.15s;\n}\n\n.tag-dropdown-close:hover {\n  color: #374151;\n  background: #f3f4f6;\n}\n\n/* ── Tag list inside dropdown ───────────────────────────────────────────── */\n\n.tag-list {\n  padding: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.tag-dropdown-empty {\n  padding: 16px;\n  text-align: center;\n  color: #9ca3af;\n  font-size: 0.85rem;\n}\n\n.tag-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 8px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.15s;\n}\n\n.tag-option:hover {\n  background: #f9fafb;\n}\n\n.tag-option.selected {\n  background: #eff6ff;\n}\n\n.tag-option input[type=\"checkbox\"] {\n  width: 15px;\n  height: 15px;\n  cursor: pointer;\n  flex-shrink: 0;\n  accent-color: #3b82f6;\n}\n\n/* The dot inside the dropdown is slightly larger */\n.tag-option .tag-dot {\n  width: 10px;\n  height: 10px;\n  flex-shrink: 0;\n}\n\n.tag-option-name {\n  font-size: 0.8rem;\n  color: #1f2937;\n  font-weight: 500;\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.tag-group {\n  font-size: 0.7rem;\n  color: #9ca3af;\n  white-space: nowrap;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
